export default {"src":"/pro/_next/static/media/bch.1f83e4f9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};